import { render, staticRenderFns } from "./candidates-list.vue?vue&type=template&id=2f5a27e4&scoped=true"
import script from "./candidates-list.vue?vue&type=script&lang=js"
export * from "./candidates-list.vue?vue&type=script&lang=js"
import style0 from "./candidates-list.vue?vue&type=style&index=0&id=2f5a27e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a27e4",
  null
  
)

export default component.exports